/* Mascarade Noire — v4 */
/* ---------------------------------------------------------------------
   Saisons : nuit d'Halloween (31 octobre, heure de Paris) et après-Halloween.
   Bandeau informatif refermable, sans urgence artificielle.
   Test : ajouter ?mn_season=night ou ?mn_season=off à l'URL.
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  function parisDate() {
    try {
      var parts = new Intl.DateTimeFormat('fr-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      return parts; // AAAA-MM-JJ
    } catch (e) {
      var d = new Date();
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }
  }
  function season() {
    var forced = /[?&]mn_season=(night|off)\b/.exec(location.search);
    if (forced) return forced[1];
    var cfg = window.MascaradeConfig || {};
    var hd = (cfg.halloweenDate || '').slice(0, 10);
    var today = parisDate();
    if (hd && today === hd) return 'night';
    if (document.documentElement.classList.contains('mn-off-season')) return 'off';
    return '';
  }
  function store(key, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, val);
    } catch (e) { return null; }
    return null;
  }
  function boot() {
    var s = season();
    if (!s) return;
    var root = document.documentElement;
    root.classList.add(s === 'night' ? 'mn-halloween-night' : 'mn-off-season');
    var key = 'mn-season-banner-' + s;
    if (store(key) === 'closed') return;
    var main = document.querySelector('main') || document.body;
    var bar = document.createElement('div');
    bar.className = 'mn-season-bar mn-season-bar--' + s;
    bar.setAttribute('role', 'note');
    var text = document.createElement('p');
    text.className = 'mn-season-bar__text';
    var link = document.createElement('a');
    link.href = '/collections/decoration-gothique';
    if (s === 'night') {
      text.appendChild(document.createTextNode('Joyeux Halloween ! Les commandes passées aujourd’hui arriveront après ce soir, mais nos décors gothiques se gardent toute l’année. '));
      link.textContent = 'Voir la déco';
    } else {
      text.appendChild(document.createTextNode('Halloween est passé, la nuit continue : décoration et bijoux gothiques à garder toute l’année. '));
      link.textContent = 'Découvrir la déco';
    }
    text.appendChild(link);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'mn-season-bar__close';
    close.setAttribute('aria-label', 'Fermer ce message');
    close.innerHTML = '<span aria-hidden="true">×</span>';
    close.addEventListener('click', function () {
      store(key, 'closed');
      bar.parentNode && bar.parentNode.removeChild(bar);
    });
    bar.appendChild(text);
    bar.appendChild(close);
    main.insertBefore(bar, main.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ---------------------------------------------------------------------
   Lien « Gérer les cookies » dans le pied de page : rouvre les préférences
   de la bannière de cookies Shopify (consentement modifiable à tout moment).
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  function openPrefs(e) {
    if (e) e.preventDefault();
    function show() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return true;
      }
      return false;
    }
    if (show()) return;
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        if (!show()) location.href = '/policies/privacy-policy';
      });
    } else {
      location.href = '/policies/privacy-policy';
    }
  }
  function addLink() {
    var privacy = document.querySelector('footer a[href="/policies/privacy-policy"], .shopify-section-group-footer-group a[href="/policies/privacy-policy"]');
    if (!privacy || document.querySelector('[data-mn-cookie-link]')) return;
    var li = privacy.closest('li');
    var a = document.createElement('a');
    a.href = '#cookies';
    a.textContent = 'Gérer les cookies';
    a.setAttribute('data-mn-cookie-link', '');
    a.addEventListener('click', openPrefs);
    if (li && li.parentNode) {
      var nli = document.createElement('li');
      nli.appendChild(a);
      li.parentNode.insertBefore(nli, li.nextSibling);
    } else {
      privacy.parentNode.insertBefore(a, privacy.nextSibling);
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('a[href="#cookies"]') : null;
    if (t && !t.hasAttribute('data-mn-cookie-link')) openPrefs(e);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addLink);
  else addLink();
})();
